// eslint-disable-next-line import/no-duplicates
import { formatDistanceToNow as _formatDistanceToNow } from 'date-fns'
// eslint-disable-next-line import/no-duplicates
import locale from 'date-fns/locale/en-US'
import {
  FORMAT_DISTANCE_LOCALE,
  FORMAT_DISTANCE_LOCALE_SHORT,
} from './constants'

const formatDistance = (
  token: keyof typeof FORMAT_DISTANCE_LOCALE,
  count: number,
  short: boolean,
  options: {
    includeSeconds?: boolean | undefined
    addSuffix?: boolean | undefined
    locale?: Locale | undefined
    comparison: number
  }
) => {
  const result = (
    short ? FORMAT_DISTANCE_LOCALE_SHORT : FORMAT_DISTANCE_LOCALE
  )[token].replace('{{count}}', count.toString())
  const finalResult =
    count === 1 && !short ? result.slice(0, result.length - 1) : result

  if (!options.addSuffix) return finalResult

  if (options.comparison > 0) {
    return 'in ' + finalResult
  } else {
    return finalResult + ' ago'
  }
}

export const formatDistanceToNow = (date: Date, short: boolean) =>
  _formatDistanceToNow(date, {
    addSuffix: true,
    locale: {
      ...locale,
      formatDistance: (
        token: keyof typeof FORMAT_DISTANCE_LOCALE,
        count: number,
        options: {
          includeSeconds?: boolean | undefined
          addSuffix?: boolean | undefined
          locale?: Locale | undefined
          comparison: number
        }
      ) => formatDistance(token, count, short, options),
    },
  })

export const formatToSpecific = (date: Date) => {
  return date
    .toLocaleString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
      timeZoneName: 'short',
    })
    .replace(/,([^\s])/, ', $1')
}
